import { render, staticRenderFns } from "./TableColumnsInput.vue?vue&type=template&id=23df9f80"
import script from "./TableColumnsInput.vue?vue&type=script&lang=js"
export * from "./TableColumnsInput.vue?vue&type=script&lang=js"
import style0 from "./TableColumnsInput.vue?vue&type=style&index=0&id=23df9f80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports